import React from 'react';
import { func, string } from 'prop-types';
import EmptyStateBase from '@alltrails/shared/components/EmptyStateBase';
import * as styles from './styles/styles.module.scss';
import Button from '../Button';

const SearchEmptyState = ({ option, srcIcon, alt, title, subText, btnText, handlePrimaryCtaClick }) => {
  return (
    <EmptyStateBase
      className={styles.container}
      icon={<img src={srcIcon} alt={alt} />}
      title={title}
      subText={subText}
      cta={
        <Button
          variant="primary"
          onClick={() => handlePrimaryCtaClick(option)}
          classes={`${option !== 'completed' ? styles.primaryCta : styles.primaryHidden}`}
        >
          {btnText}
        </Button>
      }
    />
  );
};

SearchEmptyState.propTypes = {
  option: string,
  srcIcon: string,
  alt: string,
  title: string,
  subText: string,
  btnText: string,
  handlePrimaryCtaClick: func
};

SearchEmptyState.defaultProps = {
  option: '',
  srcIcon: '',
  alt: '',
  title: '',
  subText: '',
  btnText: '',
  handlePrimaryCtaClick: null
};

export default SearchEmptyState;
